import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

function ToolsGroupPage({ title, description, items }) {
  return (
    <Paper sx={{ p: 3, borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>
      <Stack spacing={2.5}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
          <Typography color="text.secondary">{description}</Typography>
        </Box>
        <Grid container spacing={2}>
          {items.map((tool) => (
            <Grid key={tool.id} size={{ xs: 12, md: 6 }}>
              <Card variant="outlined" sx={{ borderRadius: 2 }}>
                <CardActionArea component={NavLink} to={tool.path} sx={{ p: 2.25 }}>
                  <CardContent sx={{ p: 0 }}>
                    <Typography sx={{ fontWeight: 600 }}>{tool.label}</Typography>
                    <Typography color="text.secondary" variant="body2">
                      Open {tool.label} generator
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Paper>
  );
}

export default ToolsGroupPage;
